import React from "react";
import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function FloatingWhatsApp({ message }) {
  const { waLink } = useSettings();
  return (
    <a href={waLink(message)} target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp" data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-50 bg-whatsapp text-white p-4 rounded-full shadow-lg hover:-translate-y-1 transition-transform flex items-center justify-center">
      <MessageCircle className="w-6 h-6" strokeWidth={1.5} />
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-brand rounded-full animate-ping" />
    </a>
  );
}
